export const QuantityStep:(data:any)=>{name:string, detail:string}|null = (data:any) => {//https://github.com/Stahls/stahls-wizards/blob/e899b31ecb5341c348b9eb66cc01e2574516b15c/src/letters-numbers/steps/quantity.js#L10
  if(!data?.Qty) return null

  //we will try to simplify things
  const knownKits = ['620 Kits', '170 Kits']
  return { name: "Quantity", detail: data.Qty + " " + (knownKits.includes(data.QtyUnit) ? 'Kits' : data.QtyUnit) };
}
